import React from 'react';
import './InputWithSuffix.css';

export function InputWithSuffix({
  value,
  onChange,
  placeholder,
  suffix,
  hasError,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  suffix: string;
  hasError?: boolean;
}) {
  return (
    <div className="input-suffix-wrap">
      <input
        className={`input-suffix-wrap__input${
          hasError ? ' input-suffix-wrap__input--error' : ''
        }`}
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
      />
      <span className="input-suffix-wrap__suffix">{suffix}</span>
    </div>
  );
}
